module.exports = __webpack_public_path__ + "static/media/025.7d576f4c.jpg";